import { createIconComponent } from '../../factory/create-icon-component';

export const AssortItemIcon = createIconComponent(
  'AssortItemIcon',
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(4.1, 4.1)">
      <path
        d="M3.66715 2.66634C3.66715 3.40272 3.0702 3.99967 2.33382 3.99967C1.59744 3.99967 1.00049 3.40272 1.00049 2.66634C1.00049 1.92996 1.59744 1.33301 2.33382 1.33301C3.0702 1.33301 3.66715 1.92996 3.66715 2.66634Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.56632 14.5225C1.84235 14.6571 1.14632 14.1794 1.0117 13.4554C0.877078 12.7314 1.35484 12.0354 2.07881 11.9008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="7.6672"
        cy="2.66634"
        rx="1.33333"
        ry="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="2.33382"
        cy="7.99935"
        r="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="13.0004"
        cy="2.66634"
        rx="1.33333"
        ry="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66663 12L7.16663 14.5L14.3666 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.84694 7.37493C8.53629 6.70729 7.74323 6.41788 7.07558 6.72853C6.40793 7.03918 6.11853 7.83225 6.42918 8.4999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>,
);
